import LTR from "@brand-icons/ploom/arrow-forward/arrow-forward-ltr.svg";
import RTL from "@brand-icons/ploom/arrow-forward/arrow-forward-rtl.svg";

import { iconFactory } from "../iconFactory";

export const ArrowForwardIcon = iconFactory("ArrowForwardIcon", LTR, RTL);
